document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll("media-gallery[data-presentation='carousel']").forEach((gallery) => {
    const slideshow = gallery.querySelector('slideshow-component');
    const controls = gallery.querySelector('slideshow-controls');
    const buttons = controls?.querySelectorAll('.slideshow-control');
    const slides = gallery.querySelectorAll('slideshow-slide');
    if (!slideshow || !controls || !buttons?.length || !slides.length) return;

    controls.classList.add('relune-thumbnail-controls');
    buttons.forEach((button, index) => {
      if (button.querySelector('.relune-thumbnail-image')) return;
      const source = slides[index]?.querySelector('img');
      if (!source) return;
      const thumbnail = document.createElement('img');
      thumbnail.className = 'relune-thumbnail-image';
      thumbnail.alt = '';
      thumbnail.setAttribute('aria-hidden', 'true');
      thumbnail.loading = 'lazy';
      const sourceUrl = source.currentSrc || source.src;
      thumbnail.src = sourceUrl.replace(/([?&]width=)\d+/, (match, prefix) => `${prefix}160`);
      button.appendChild(thumbnail);
    });

    const createScrollButton = (direction, label) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `relune-thumb-scroll relune-thumb-scroll--${direction}`;
      button.setAttribute('aria-label', label);
      button.innerHTML = direction === 'up'
        ? '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="m5 12.5 5-5 5 5"/></svg>'
        : '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="m5 7.5 5 5 5-5"/></svg>';
      return button;
    };

    const upButton = createScrollButton('up', 'Show previous product images');
    const downButton = createScrollButton('down', 'Show more product images');
    slideshow.append(upButton, downButton);

    const updateScrollButtons = () => {
      const maxScroll = controls.scrollHeight - controls.clientHeight;
      const hasOverflow = maxScroll > 4;
      upButton.hidden = !hasOverflow || controls.scrollTop <= 2;
      downButton.hidden = !hasOverflow || controls.scrollTop >= maxScroll - 2;
    };

    const scrollThumbnails = (direction) => {
      const distance = Math.max(168, Math.round(controls.clientHeight * 0.62));
      controls.scrollBy({ top: direction * distance, behavior: 'smooth' });
    };

    upButton.addEventListener('click', () => scrollThumbnails(-1));
    downButton.addEventListener('click', () => scrollThumbnails(1));
    controls.addEventListener('scroll', updateScrollButtons, { passive: true });
    window.addEventListener('resize', updateScrollButtons, { passive: true });
    requestAnimationFrame(updateScrollButtons);
  });
});
